export default __webpack_public_path__ + "static/media/dash-training-manual.a72cd9a6.svg";